import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
  GalleryField,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
// components

export default function Add(props) {
  const core = useCore();

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ country_id: "118" }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");
            await props.submit(transformTranslateFromValues(values));
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="first_name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="_en*first_name*text"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="last_name"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی(en)"
                    label="نام خانوادگی(en) :"
                    name="_en*last_name*text"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام کاربری"
                    label="نام کاربری :"
                    name="user_name"
                    component={TextField}
                    validate={isUserName}
                  />
                  <div className="col-span-2 md:grid md:grid-cols-2 md:gap-3">
                    <Field
                      placeholder="گذرواژه"
                      label="گذرواژه :"
                      name="password"
                      component={TextField}
                      type={"password"}
                    />
                    <Field
                      placeholder="تکرار گذرواژه"
                      label="تکرار گذرواژه :"
                      name="password_confirmation"
                      type={"password"}
                      component={TextField}
                    />
                  </div>
                  <Field
                    placeholder="آدرس و شماره تلفن کافه"
                    label="ادرس و شماره تلفن :"
                    name="address"
                    component={TextArea}
                  />
                  <Field
                    placeholder="آدرس و شماره تلفن کافه(en)"
                    label="ادرس و شماره تلفن(en) :"
                    name="_en*address*text"
                    component={TextArea}
                  />
                  <Field
                    label="تصویر افقی :"
                    name="cafe_media_id"
                    component={GalleryField}
                    dataType="id"
                  />
                  <Field
                    label="تصویر عمودی :"
                    name="cafe_mobile_media_id"
                    component={GalleryField}
                    dataType="id"
                  />
                </div>
                <div
                  className="w-100 my-3"
                  style={{ height: 250, backgroundColor: "#eee" }}
                >
                  <h1 className="text-center">MAP</h1>
                </div>
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  {core.rolesLoad ? (
                    <Loading />
                  ) : (
                    <Field
                      label="نقش ها :"
                      name="roles"
                      valueOnly
                      component={MultiSelect}
                      options={core.roles || []}
                    />
                  )}
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
